import type { ExcalidrawImperativeAPI } from "../../packages/excalidraw/types";

/**
 * Shared handle to the current Excalidraw imperative API for the auto-mindmap
 * picker entry (issue #45).
 *
 * The Notion search picker is rendered deep inside the core Excalidraw
 * component tree, which only hands it `render` + `excalidrawAppState` — not the
 * imperative API that `generateMindmapFromPage` needs (getSceneElements,
 * updateScene, getAppState, scrollToContent). The app shell sets this ref once
 * the API is ready; the picker reads it when the user asks to generate a map.
 */
let current: ExcalidrawImperativeAPI | null = null;

export const setMindmapApi = (api: ExcalidrawImperativeAPI | null): void => {
  current = api;
};

export const getMindmapApi = (): ExcalidrawImperativeAPI | null => current;
